module.exports = __webpack_public_path__ + "img/10.0569c112.png";